module.exports = __webpack_public_path__ + "webpc/img/icon_assets_1.4116752f.png";